function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(2.099 2.071)"
}, React.createElement("g", null, React.createElement("path", {
  fill: "#194C73",
  d: "M94.445,1.385v93.088H1.357V1.385H94.445 M97.901-2.071h-100v100h100V-2.071L97.901-2.071z"
})), React.createElement("circle", {
  fill: "#009AD7",
  cx: 47.901,
  cy: 24.024,
  r: 8.576
}), React.createElement("circle", {
  fill: "#009AD7",
  cx: 47.901,
  cy: 47.929,
  r: 7.147
}), React.createElement("circle", {
  fill: "#009AD7",
  cx: 73.547,
  cy: 47.928,
  r: 8.576
}), React.createElement("circle", {
  fill: "#009AD7",
  cx: 22.374,
  cy: 47.928,
  r: 5.717
}), React.createElement("circle", {
  fill: "#009AD7",
  cx: 47.901,
  cy: 71.314,
  r: 5.717
}));

var SvgConvergence = function SvgConvergence(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "convergence",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgConvergence, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Convergence.d9515ed0.svg";
export { ForwardRef as ReactComponent };